import _ from 'lodash';

import { selectProjectList, selectProjectTotals } from '../../selectors';

export const selectProjectMetrics = (store) => {
  const projects = selectProjectList(store);
  let openJobs = 0;
  let possibleJobs = 0;
  let monthlyRevenue = 0;
  let fixedRevenue = 0;

  projects.forEach(project => {
    if (project.status === "closed" || project.status === "held") {
      return;
    } else {
      const totals = selectProjectTotals(store, project);
      totals.forEach(total => {
        if (total.type === "monthly") {
          monthlyRevenue += total.amount;
        } else if (total.type === "fixed") {
          fixedRevenue += total.amount;
        }
      });

      if (project.status === "active") {
        openJobs++;
      } else if (!project.status) {
        possibleJobs++;
      }
    }
  });

  return ([
    {
      type: "horizontal",
      label: "Open Jobs",
      display: openJobs,
    },
    {
      type: "horizontal",
      label: "Possible Jobs",
      display: possibleJobs,
    },
    {
      type: "vertical",
      label: "Monthly revenue",
      display: `$${monthlyRevenue.toFixed(2)}`,
    },
    {
      type: "vertical",
      label: "Fixed revenue",
      display: `$${fixedRevenue.toFixed(2)}`,
    },
  ]);
}



// WEBPACK FOOTER //
// ./src/store/selectors/metrics/projects.js